import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../services/actor.service';
import { AppData } from '../../../../models/appdata';
import { SaveSpecimenInfoRequest, SpecimenData } from '../../../../models/lab/testinfo.model';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbeditspecimen',
  templateUrl: './editspecimen.modal.html',
  styleUrls: ['./editspecimen.modal.scss']
})

export class NgbEditSpecimenModal implements OnInit {
  @Input() SpecimenData: SpecimenData;
  public ShowList: boolean = true; 

  public model: SpecimenData = {
    IsSpecimenAvailable: true,
    SpecimenSource: 'Serum',
    Quantity: 5,
    UOM: 'ML',
    Organism: '',
    HasTestMethod: false,
    TestMethod: ''
  };

  constructor(
    public activeModal: NgbActiveModal,
    private actorService: ActorService,
    private toastrService: NGXToastrService
  ) { }

  ngOnInit() {
    if (this.SpecimenData) {
      this.model = { ...this.SpecimenData };
    }
  }

  onSubmit() {
    const req = new SaveSpecimenInfoRequest();
    req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    req.IsSpecimenAvailable = this.model.IsSpecimenAvailable;
    req.SpecimenSource = this.model.SpecimenSource;
    req.Quantity = this.model.Quantity;
    req.UOM = this.model.UOM;
    req.Organism = this.model.Organism;
    req.HasTestMethod = this.model.HasTestMethod;
    req.TestMethod = this.model.TestMethod;

    this.actorService.SaveSpecimenInfo(req).subscribe(
      (res) => {
        this.toastrService.ToasterSuccessAlertParam('Specimen Saved Successfully!');
        this.activeModal.close(this.model);
      },
      (err) => {
        this.toastrService.ToasterSuccessAlertParam('Specimen Saved Successfully!');
        this.activeModal.close(this.model);
      }
    );
  }

  ModalClose() {
    this.activeModal.dismiss();
  }
}
